:host {
  display: block;
  max-width: 100%;
  max-height: 100%;
  padding-top: calc(var(--spacer) * 2);
}

gz-labeled-content {
  width: 500px;
  --label-width-percentage: 25%;
  --value-width-percentage: 75%;
}

gz-label-switch {
  --active-border-color: var(--blue-layout-400-primary);
  --active-text-color: var(--blue-layout-400-primary);
}

.loading-container {
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50vh;

  gz-progress-spinner {
    display: flex;
    justify-content: center;
  }
}

.expand-plan-section {
  width: 375px;
  padding-right: calc(var(--spacer) * 8);
}

gz-label-switch[class*='label-switch'] {
  width: 200px;
}

gz-labeled-content[class*='number-of-years']::part(content) {
  margin-top: -8px;
}

gz-link[class*='no-padding'] {
  --wrapper-padding: 0;
}

gz-trial-home-page {
  margin-left: calc(var(--spacer)* -3);
  margin-top: calc(var(--spacer)* -5);
}
